import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DoaAttestationComponent',
    props: {
        modelValue: { type: Boolean, default: false },
        isEditable: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        // Smart Submit (LAM-5919) prescriber DOA attestation, shown inside the Submission Options panel.
        const emit = __emit;
        const props = __props;
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, { class: "section-container" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                        cols: "12",
                        class: "header-with-select-box"
                    }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("h3", { class: "text-primary weight-600" }, "Delegation of Authority", -1)
                            ]))]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                                id: "doa-attestation",
                                "model-value": props.modelValue,
                                disabled: !props.isEditable,
                                color: "accent",
                                "hide-details": "",
                                label: "CHECK THIS BOX IF THERE IS A DELEGATION OF AUTHORITY (DOA) WITH THIS PRESCRIBER",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:modelValue', $event === true)))
                            }, null, 8, ["model-value", "disabled"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
